import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export const getListSelfCares = async (search?: any, page?: any) => {
  let url = `${API_URLS}/self-cares?populate=*&sort=cycle:asc&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getSelfCareById = async (id: any) => {
  let url = `${API_URLS}/self-cares/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getSelfCareByCycle = async (cycle: any) => {
  let url = `${API_URLS}/self-cares?filters[cycle]=${cycle}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getSelfCareByIdWithGroupedPerWeek = async (id: any) => {
  let url = `${API_URLS}/self-cares/check/${id}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getSelfCareCategories = async () => {
  let url = `${API_URLS}/self-care-categories?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postSelfCare = async (datas: any) => {
  try {
    const {name, description, cycle} = datas
    const body = {
      data: {
        name,
        description,
        cycle,
      },
    }
    const response = await axios.post(`${API_URLS}/self-cares`, body)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putSelfCare = async (datas: any) => {
  try {
    const {id, name, description, cycle} = datas
    const body = {
      data: {
        name,
        description,
        cycle,
      },
    }
    const response = await axios.put(`${API_URLS}/self-cares/${id}`, body)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const bulkCreateUpdateActivities = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/self-care-activities/create`, datas)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteSelfCare = async (id: any) => {
  try {
    const response = await axios.delete(`${API_URLS}/self-cares/${id}`)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteActivities = async (id: any) => {
  try {
    const response = await axios.delete(`${API_URLS}/self-care-activities/${id}`)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const pushNotification = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/self-care-activities/push-notification`, datas)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
